import React, { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Link } from 'react-router-dom';
import useToken from 'hooks/useToken';
import ImagenTipoArchivo from './ImagenTipoArchivo';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FiPaperclip, FiPlus, FiCheck, FiDownload, FiTrash2, FiUser, FiFile, FiCalendar, FiClock } from 'react-icons/fi';
import { useToast } from 'context/providers/ToastProvider';

const SeccionArchivos = ({
    idOrden,
    GuardarComentario,
    orden,
    onComentarioAgregado
}) => {

    //AUTENTICACION
    const { token, idCatTipoUsuario, setToken, nombreCompleto } = useToken();
    const { showErrorToast, showSuccessToast } = useToast();
    const [loadingDeleteFile, setLoadingDeleteFile] = useState(false);
    const [loadingUploadFile, setLoadingUploadFile] = useState(false);
    const [archivos, setArchivos] = useState([]);
    const [dataFile, setDataFile] = useState({});
    const [procesando, setProcesando] = useState(true);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [archivoToDelete, setArchivoToDelete] = useState(null);
    const [confirmText, setConfirmText] = useState('');
    const fileInputRef = React.useRef(null);


    /**
     * Carga archivo
     */
    const onSubmitCargarArchivo = async (e) => {
        e.preventDefault();
        setLoadingUploadFile(true);

        if (dataFile.vArchivo == null) {
            showErrorToast('Es obligatorio cargar un archivo');
            setLoadingUploadFile(false);
            return false;
        }

        var data = new FormData()
        data.append('FileName', dataFile.vNombreDocumento);
        data.append('FormFile', dataFile.vArchivo);
        data.append('idOrden', idOrden);

        const response = await fetch("/api/orden/CargarArchivo", {
            method: 'POST',
            body: data,
            headers:
            {
                'Authorization': 'Bearer ' + token
            }
        }).catch((error) => {
            
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();
            console.log(data);

            if (data.iResponseType == 1) {

                const objResponse = JSON.parse(data.detalles);
                console.log(objResponse);

                //Guardamos un comentario para notificar el historial
                GuardarComentario(idOrden, "<b>" + nombreCompleto + "</b> subió el archivo:  <b>" + dataFile.vNombreDocumento + "</b>", 2, orden, (comentarioBD) => {
                    onComentarioAgregado(comentarioBD);
                }, (error) => {
                    showErrorToast(error);
                    
                });
                setDataFile({}); // se vacia la cache del componente
                setArchivos(objResponse);
                if (fileInputRef.current) {
                    fileInputRef.current.value = "";
                }

            } else {
                showErrorToast(data.vMessage);
                
            }

        }
        else {
            
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setLoadingUploadFile(false);
    };


    /**
    * Elimina archivos
    */
    const eliminaArchivo = async (idOrdenArchivo_, id_, vNombreArchivo_) => {
        console.log(idOrdenArchivo_)
        setLoadingDeleteFile(idOrdenArchivo_);

        var idCatTipoUsuario1 = 3

        const response = await fetch("/api/orden/deleteFile/?idOrdenArchivo=" + idOrdenArchivo_ + "&idOrden=" + id_ + "&name=" + vNombreArchivo_ + "&idCatTipoUsuario=" + idCatTipoUsuario1,
            {
                method: 'GET',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            }).catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                

                console.log('Hubo un problema con la peticion Fetch:' + error);

                setLoadingDeleteFile(false);
            });

        if (response.ok) {
            const objResponse = await response.json();
            console.log(objResponse);

            if (objResponse.iResponseType == 1) {

                const data = JSON.parse(objResponse.detalles);
                setArchivos(data);
                //Guardamos un comentario para notificar el historial
                GuardarComentario(idOrden, "<b>" + nombreCompleto + "</b> eliminó el archivo: <b>" + vNombreArchivo_ + "</b>", 2, orden, (comentarioBD) => {
                    onComentarioAgregado(comentarioBD);
                }, (error) => {
                    showErrorToast(error);
                    
                });
                showSuccessToast("Archivo Eliminado!");

            } else {
                showErrorToast(objResponse.vMessage);
                
            }

            setLoadingDeleteFile(false);
        }
        else {
            showErrorToast('Hubo un problema con la peticion Fetch:');
            

            setLoadingDeleteFile(false);
        }


    }

    /**
    * Obtiene archivos de orden
    */
    const ObtenerArchivosDeOrden = async () => {
        setProcesando(true);

        const response = await fetch("/api/orden/ObtenerArchivosDeOrden/?id=" + idOrden, {
            method: 'GET',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {

                showErrorToast('' + error.message);
                

                console.log('Hubo un problema con la peticion Fetch:' + error.message);

                setProcesando(false);
            });

        if (response.ok) {
            const data = await response.json();
            console.log("========== ARCHIVOS DE ORDEN ==========");
            //console.log("data: ", data);

            setArchivos(data["table1"])
            setProcesando(false);
        }
        else {

            showErrorToast(response.status + ' ' + response.statusText);
            

            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
            setProcesando(false);
        }

    };

    /**
     * Obtiene archivos al cambiar id
     */
    useEffect(() => {

        setArchivos([]);

        if (idOrden) {
            ObtenerArchivosDeOrden();
        }
    }, [idOrden]);

    return (
        <div className="document-section py-3 rounded border shadow-sm p-3">
            {procesando ? (
                <div
                    className="w-100 d-flex justify-content-center align-items-center"
                    style={{ minHeight: 120 }}
                >
                    <div
                        style={{
                            width: "100%",
                            maxWidth: 1200,
                            background: "transparent",
                            borderRadius: 8,
                            border: "1px solid #e3e3e3",
                            boxShadow: "0 2px 8px #0001",
                            padding: 0,
                        }}
                    >
                        {/* Encabezado simulado */}
                        <div
                            style={{
                                display: "flex",
                                background: "transparent",
                                padding: "12px 32px",
                                borderBottom: "1px solid #e3e3e3",
                                fontWeight: 600,
                                fontSize: 15,
                            }}
                        >
                            <div style={{ flex: 2 }}>
                                <Skeleton width={300} height={20} />
                            </div>
                            <div style={{ flex: 1, textAlign: "center" }}>
                                <Skeleton width={120} height={20} />
                            </div>
                        </div>
                        {/* Filas simuladas */}
                        {[1, 2, 3, 4].map((i) => (
                            <div
                                key={i}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "8px 32px",
                                    borderBottom: i < 2 ? "1px solid #e3e3e3" : "none",
                                }}
                            >
                                <div style={{ flex: 2 }}>
                                    <Skeleton height={25} width="80%" />
                                </div>
                                <div style={{ flex: 1, textAlign: "center" }}>
                                    <Skeleton height={16} width={100} />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            ) : (
                <>
                    <div className="rounded p-3 border" style={{ backgroundColor: 'transparent' }}>
                        {/* Header compacto */}
                        <div className="d-flex justify-content-between align-items-center mb-2 pb-2 border-bottom">
                            <div className="d-flex align-items-center">
                                <FiPaperclip className="text-muted me-2" />
                                <span className="fw-medium text-dark">Documentos</span>
                                {archivos.length > 0 && (
                                    <span className="badge bg-light text-muted ms-2 rounded-pill small">
                                        {archivos.length}
                                    </span>
                                )}
                            </div>

                            {/* Formulario de carga inline y compacto - solo para idCatTipoUsuario === "1" */}
                            {idCatTipoUsuario === "1" && (
                                <div className="d-flex align-items-center">
                                    <div className="position-relative me-2">
                                        <input
                                            type="file"
                                            id="fileInput"
                                            className="d-none"
                                            disabled={loadingUploadFile}
                                            onChange={(e) => {
                                                if (e.target.files.length > 0) {
                                                    setDataFile({
                                                        ...dataFile,
                                                        vArchivo: e.target.files[0],
                                                        vNombreDocumento: e.target.files[0].name,
                                                        vTipoDocumento: e.target.files[0].type,
                                                        vTamano: e.target.files[0].size,
                                                    });
                                                }
                                            }}
                                            ref={fileInputRef}
                                        />
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-outline-primary d-flex align-items-center px-2 py-1"
                                            onClick={() => fileInputRef.current?.click()}
                                            disabled={loadingUploadFile}
                                        >
                                            <FiPlus className="me-1" size={12} />
                                            <span className="small">Subir</span>
                                        </button>
                                    </div>

                                    {dataFile.vArchivo && (
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-success d-flex align-items-center px-2 py-1"
                                            onClick={onSubmitCargarArchivo}
                                            disabled={loadingUploadFile}
                                        >
                                            {loadingUploadFile ? (
                                                <>
                                                    <div className="spinner-border me-1"
                                                        style={{ width: '12px', height: '12px' }} role="status"></div>
                                                    <span className="small">Cargando...</span>
                                                </>
                                            ) : (
                                                <>
                                                    <FiCheck className="me-1" size={12} />
                                                    <span className="small">Cargar</span>
                                                </>
                                            )}
                                        </button>
                                    )}
                                </div>
                            )}
                        </div>

                        {/* Lista de archivos con scroll */}
                        {archivos.length > 0 ? (
                            <div className="overflow-auto" style={{ maxHeight: '300px' }}>
                                {archivos.map((a, i) => (
                                    <div key={i} className="d-flex align-items-start py-2 px-2 border-bottom border-light rounded mb-1">
                                        {/* Icono del archivo */}
                                        <div className="me-2 d-flex align-items-center justify-content-center flex-shrink-0"
                                            style={{ width: '24px', height: '24px' }}>
                                            <ImagenTipoArchivo vNombreArchivo={a.vNombreArchivo} />
                                        </div>

                                        {/* Información del archivo */}
                                        <div className="flex-grow-1 overflow-hidden me-2">
                                            <div className="d-flex align-items-center justify-content-between mb-1">
                                                <Link
                                                    to={"/api/orden/ongetfile/?idOrden=" + idOrden + "&name=" + a.vNombreArchivo}
                                                    target="_blank"
                                                    className="text-truncate fw-medium text-dark small text-decoration-none"
                                                    title={a.vNombreArchivo}
                                                  
                                                >
                                                    {a.vNombreArchivo}
                                                </Link>
                                            </div>

                                            {/* Información adicional del usuario y fecha */}
                                            <div className="d-flex flex-wrap gap-2 small text-muted">
                                                {a.vCreatedUser && (
                                                    <div className="d-flex align-items-center">
                                                        <FiUser className="me-1" size={10} />
                                                        <span>{a.vCreatedUser}</span>
                                                    </div>
                                                )}
                                                {a.dCreatedDate && (
                                                    <div className="d-flex align-items-center">
                                                        <FiCalendar className="me-1" size={10} />
                                                        <span>
                                                            {new Date(a.dCreatedDate).toLocaleDateString('es-ES', {
                                                                day: 'numeric',
                                                                month: 'long',
                                                                year: 'numeric'
                                                            })}
                                                        </span>
                                                    </div>
                                                )}
                                                {a.dCreatedDate && (
                                                    <div className="d-flex align-items-center">
                                                        <FiClock className="me-1" size={10} />
                                                        <span>
                                                            {new Date(a.dCreatedDate).toLocaleTimeString('es-ES', {
                                                                hour: '2-digit',
                                                                minute: '2-digit'
                                                            })}
                                                        </span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        {/* Acciones compactas */}
                                        <div className="d-flex align-items-center flex-shrink-0" style={{ gap: '4px' }}>
                                            {/* Botón descargar */}
                                            <Link
                                                to={"/api/orden/ongetfile/?idOrden=" + idOrden + "&name=" + a.vNombreArchivo}
                                                target="_blank"
                                                className="btn btn-sm btn-outline-primary p-1 d-flex align-items-center justify-content-center rounded"
                                                style={{ width: '28px', height: '28px' }}
                                                title="Descargar archivo"
                                            >
                                                <FiDownload size={14} />
                                            </Link>

                                            {/* Botón eliminar - condición original del primer código */}
                                            {idCatTipoUsuario !== "3" && !(idCatTipoUsuario === "3" && a.esAdministrador === 1) && (
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-outline-danger p-1 d-flex align-items-center justify-content-center rounded"
                                                    style={{ width: '28px', height: '28px' }}
                                                    onClick={() => {
                                                        setArchivoToDelete({
                                                            idOrdenArchivo: a.idOrdenArchivo,
                                                            idOrden: a.idOrden,
                                                            vNombreArchivo: a.vNombreArchivo
                                                        });
                                                        setConfirmText('');
                                                        setShowDeleteModal(true);
                                                    }}
                                                    title="Eliminar archivo"
                                                    disabled={loadingDeleteFile === a.idOrdenArchivo}
                                                >
                                                    {loadingDeleteFile === a.idOrdenArchivo ? (
                                                        <div className="spinner-border text-danger"
                                                            style={{ width: '12px', height: '12px' }} role="status"></div>
                                                    ) : (
                                                        <FiTrash2 size={14} />
                                                    )}
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="text-center py-4">
                                <div className="mb-2">
                                    <FontAwesomeIcon icon="file-lines" className="text-muted" style={{ fontSize: '2rem' }} />
                                </div>
                                <p className="text-muted mb-0 small">No hay documentos adjuntos para esta orden</p>
                            </div>
                        )}

                        {/* Información de archivo seleccionado */}
                        {dataFile.vArchivo && idCatTipoUsuario === "1" && (
                            <div className="mt-2 p-2 bg-light rounded">
                                <div className="d-flex align-items-center justify-content-between mb-1">
                                    <span className="text-muted small fw-medium">
                                        Archivo seleccionado:
                                    </span>
                                    <button
                                        type="button"
                                        className="btn-close btn-sm"
                                        onClick={() => {
                                            setDataFile({
                                                ...dataFile,
                                                vArchivo: null,
                                                vNombreDocumento: '',
                                                vTipoDocumento: '',
                                                vTamano: 0,
                                            });
                                            if (fileInputRef.current) {
                                                fileInputRef.current.value = '';
                                            }
                                        }}
                                    ></button>
                                </div>
                                <div className="small text-muted d-flex align-items-center">
                                    <FiFile className="me-1" size={10} />
                                    <span className="text-truncate" style={{ maxWidth: '200px' }}>
                                        {dataFile.vNombreDocumento}
                                    </span>
                                </div>
                                <div className="small text-muted mt-1">
                                    Nota de Venta / Factura pdf o xml / CSF
                                </div>
                            </div>
                        )}
                    </div>
                </>
            )}

            {/* Modal de confirmación para eliminar - manteniendo la lógica original */}
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmar eliminación</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>¿Estás seguro de que deseas eliminar el archivo: <strong style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>{archivoToDelete?.vNombreArchivo}</strong>?</p>
                    <p>Para confirmar, escribe <strong>ELIMINAR</strong> en el campo de texto:</p>
                    <Form.Control
                        type="text"
                        value={confirmText}
                        onChange={(e) => setConfirmText(e.target.value)}
                        placeholder="Escribe 'ELIMINAR' para confirmar"
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                        Cancelar
                    </Button>
                    <Button
                        variant="danger"
                        disabled={confirmText.toUpperCase() !== 'ELIMINAR'}
                        onClick={() => {
                            if (confirmText.toUpperCase() === 'ELIMINAR' && archivoToDelete) {
                                eliminaArchivo(
                                    archivoToDelete.idOrdenArchivo,
                                    archivoToDelete.idOrden,
                                    archivoToDelete.vNombreArchivo
                                );
                                setShowDeleteModal(false);
                            }
                        }}
                    >
                        Eliminar
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}



SeccionArchivos.propTypes = {
    idOrden: PropTypes.string,
    GuardarComentario: PropTypes.func,
    orden: PropTypes.object,
    onComentarioAgregado: PropTypes.func
};

export default SeccionArchivos;